import React from "react";

import { useGetVerificationEditingRequests } from "utils";

import { EDITING_REQUEST_TYPE, PRACTICE_SLUG, VerificationEditingRequest } from "models";

import { Row } from "components";

import { PracticeList } from "pages/admin/verifications/components/lists/PracticeList";
import { EditingRequestInsightCards } from "pages/admin/verifications/components/misc/EditingRequestInsightCards";
import { TillageAndSeedingTable } from "pages/admin/verifications/components/misc/TillageAndSeedingTable";
import { TillageAndSeedingTimeline } from "pages/admin/verifications/components/misc/TillageAndSeedingTimeline";

export const TillageAndSeedingList = ({ farmId, onUpdate }: { farmId: string; onUpdate?: () => void }) => {
  const { data: editingRequests, isLoading: isLoadingEditingRequests } = useGetVerificationEditingRequests({ farmId, isAdmin: true });

  // Helper function to get editing requests for a specific field
  const getFieldEditingRequests = (fieldId: string): VerificationEditingRequest[] => editingRequests?.filter((request) => request.fieldId === fieldId) ?? [];

  return (
    <>
      <Row className="padding-bottom-200">
        {/* prelint-ignore-col */}
        {/* Cols are inside component */}
        <EditingRequestInsightCards
          loading={isLoadingEditingRequests}
          editingRequests={editingRequests ?? []}
          requestTypes={[EDITING_REQUEST_TYPE.TILLAGE, EDITING_REQUEST_TYPE.SEEDING]}
        />
      </Row>

      <PracticeList
        farmId={farmId}
        practiceSlugs={[PRACTICE_SLUG.TILLAGES, PRACTICE_SLUG.SEEDINGS]}
        onUpdate={onUpdate}
        renderTimeline={(fieldId) => <TillageAndSeedingTimeline fieldId={fieldId} farmId={farmId} />}
        renderExpandedContent={(field) => <TillageAndSeedingTable field={field} farmId={farmId} editingRequests={getFieldEditingRequests(field.id)} />}
        additionalDrawerProps={{
          editingRequests: editingRequests ?? [],
        }}
      />
    </>
  );
};
